import ScoopMApi from '../../../../references/scoopm-api';

export default function getAdditionalCsvData(drivers) {
  const driverIds = drivers.map(d => d.key);
  return ScoopMApi.instance.users.emails
    .getOver100Safe(driverIds)
    .then(users => drivers.map(driver => Object.assign({}, driver, {email: users[driver.key].email})));
}
